import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({
    providedIn: "root"
})
export class SplashScreenService {
    private showSplashScreen = new BehaviorSubject<boolean>(true);
    showSplashScreen$ = this.showSplashScreen.asObservable();

    hideSplashScreen() {
        this.showSplashScreen.next(false);
    }
}
